<template>
    <div class="contact">
        <main-content />
    </div>
</template>

<script>
import mainContent from '@/components/contact/index.vue'

export default {
    name: 'contact',
    components: {
        mainContent
    }
}
</script>
